var _classCallCheck = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

/**
 * JsonWebKey
 */
var JsonWebKey =
/**
 * Constructor
 */
function JsonWebKey(data) {
  "use strict";

  _classCallCheck(this, JsonWebKey);

  Object.assign(this, data);
};
/**
 * Export
 */


module.exports = JsonWebKey;